import React from 'react'
import Header from '../common/Header.js'
import InnerBanner from '../common/InnerBanner.js'
import Footer from '../common/Footer.js'
import { Link } from 'react-router-dom'

export const Faq = () => {
  return (
    <>
      <Header />

      <InnerBanner title="FAQs" />

      <div className="w3l-faq-main">
        <div className="faq-sec sec-padding">
          <div className="wrapper">
            <div className="faq-cont">
              <div className="about-right-faq">

                <div className="bg-warning text-dark p-3">
                  <b>Important:</b> Please read the FAQ, Terms & Conditions,
                  and applicable DLMP21 reward rules before participating.
                </div>

                <p className="mt-4">
                  Have questions about DLMP21? Find answers about registration,
                  purchases, your DLMP Code, the customer network and eligible
                  rewards below.
                </p>

                <p className="mt-3">
                  DLMP21 connects customers with participating local businesses
                  through a structured customer reward network.
                </p>

                <div className="sub-accor">
                  <h3 className="title-w3-ab text-uppercase mt-5 mb-4">
                    Frequently Asked Questions
                  </h3>

                  <ul className="accordion css-accordion">

                    {/* FAQ 1 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq1"
                      />

                      <label htmlFor="faq1" className="accordion-item-hd">
                        What is DLMP21?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd accordion-item-bd-2">
                        <h6 className="accordion-textm">
                          About DLMP21
                        </h6>

                        <p>
                          DLMP21 is a platform that connects customers with
                          participating local businesses. Customers can make
                          eligible purchases, provide their unique DLMP Code
                          and participate in the DLMP21 customer reward
                          network.
                        </p>
                      </div>
                    </li>

                    {/* FAQ 2 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq2"
                      />

                      <label htmlFor="faq2" className="accordion-item-hd">
                        How can I join DLMP21?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Create your account
                        </h6>

                        <p>
                          You can create a DLMP21 customer account by completing
                          the registration process and providing the required
                          details.
                        </p>

                        <Link
                          to="/register"
                          className="action btn button-eff mt-3"
                        >
                          Register Now
                        </Link>
                      </div>
                    </li>

                    {/* FAQ 3 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq3"
                      />

                      <label htmlFor="faq3" className="accordion-item-hd">
                        What is a DLMP Code?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Your unique customer code
                        </h6>

                        <p>
                          Your DLMP Code is a unique code associated with your
                          DLMP21 customer account. You provide this code to a
                          participating business when making an eligible
                          purchase so that the purchase can be recorded on the
                          platform.
                        </p>
                      </div>
                    </li>

                    {/* FAQ 4 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq4"
                      />

                      <label htmlFor="faq4" className="accordion-item-hd">
                        Where can I shop through DLMP21?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Participating businesses
                        </h6>

                        <p>
                          You can shop from businesses participating in the
                          DLMP21 network. You can use the shop search to find
                          participating businesses by location and category.
                        </p>

                        <Link
                          to="/shops"
                          className="action btn button-eff mt-3"
                        >
                          Find Shops
                        </Link>
                      </div>
                    </li>

                    {/* FAQ 5 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq5"
                      />

                      <label htmlFor="faq5" className="accordion-item-hd">
                        What is the ₹1,000 monthly purchase requirement?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Eligible monthly purchases
                        </h6>

                        <p>
                          Under the applicable DLMP21 program rules, customers
                          are required to make eligible purchases of ₹1,000 or
                          more during the applicable monthly period to qualify
                          for relevant network and reward calculations.
                        </p>

                        <p className="mt-3">
                          Please refer to the current DLMP21 terms and reward
                          rules for the exact eligibility requirements.
                        </p>
                      </div>
                    </li>

                    {/* FAQ 6 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq6"
                      />

                      <label htmlFor="faq6" className="accordion-item-hd">
                        How is my purchase recorded?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Show your DLMP Code
                        </h6>

                        <p>
                          After making an eligible purchase from a participating
                          business, provide your DLMP Code to the franchisee or
                          participating business. The purchase can then be
                          recorded through the DLMP21 platform according to the
                          applicable process.
                        </p>
                      </div>
                    </li>

                    {/* FAQ 7 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq7"
                      />

                      <label htmlFor="faq7" className="accordion-item-hd">
                        How does the 21-level customer network work?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Customer network structure
                        </h6>

                        <p>
                          DLMP21 provides a structured customer network that
                          can extend up to 21 levels. Network activity and
                          applicable rewards are handled according to the
                          DLMP21 reward structure and eligibility rules.
                        </p>

                        <p className="mt-3">
                          Participation in the network does not by itself
                          guarantee a particular reward or income amount.
                        </p>
                      </div>
                    </li>

                    {/* FAQ 8 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq8"
                      />

                      <label htmlFor="faq8" className="accordion-item-hd">
                        How are rewards calculated?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Reward calculation
                        </h6>

                        <p>
                          Applicable rewards are calculated based on eligible
                          purchases, the applicable network structure,
                          commission allocation and the eligibility rules in
                          effect at the time of calculation.
                        </p>

                        <p className="mt-3">
                          The actual reward amount may vary and is subject to
                          the applicable DLMP21 terms and conditions.
                        </p>
                      </div>
                    </li>

                    {/* FAQ 9 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq9"
                      />

                      <label htmlFor="faq9" className="accordion-item-hd">
                        When will eligible rewards be credited?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Reward payout
                        </h6>

                        <p>
                          Eligible rewards are processed according to the
                          applicable DLMP21 payout schedule, verification
                          process and eligibility conditions.
                        </p>

                        <p className="mt-3">
                          Please check your account and the current payout rules
                          for the applicable processing period.
                        </p>
                      </div>
                    </li>

                    {/* FAQ 10 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq10"
                      />

                      <label htmlFor="faq10" className="accordion-item-hd">
                        Can a local business join DLMP21?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          For participating businesses
                        </h6>

                        <p>
                          Local businesses can participate in the DLMP21
                          network subject to the applicable registration,
                          verification and business terms.
                        </p>

                        <p className="mt-3">
                          Participating businesses can connect with customers
                          through the DLMP21 platform and record eligible
                          purchases made through the network.
                        </p>
                      </div>
                    </li>

                    {/* FAQ 11 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq11"
                      />

                      <label htmlFor="faq11" className="accordion-item-hd">
                        Is any reward or income guaranteed?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Important information
                        </h6>

                        <p>
                          No specific reward or income amount should be
                          considered guaranteed. Eligibility, purchase
                          activity, network conditions and the applicable
                          DLMP21 reward rules determine whether and how much a
                          customer may receive.
                        </p>
                      </div>
                    </li>

                    {/* FAQ 12 */}
                    <li className="accordion-item">
                      <input
                        className="accordion-item-input"
                        type="checkbox"
                        name="accordion"
                        id="faq12"
                      />

                      <label htmlFor="faq12" className="accordion-item-hd">
                        Where can I check my account and reward information?
                        <span className="accordion-item-hd-cta">
                          &#9650;
                        </span>
                      </label>

                      <div className="accordion-item-bd">
                        <h6 className="accordion-textm">
                          Your DLMP21 account
                        </h6>

                        <p>
                          Log in to your DLMP21 account to view the information
                          available for your profile, purchases, network
                          activity and applicable rewards.
                        </p>
                      </div>
                    </li>

                  </ul>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}